import { Indicators } from './Indicators';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const IndicatorsWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <Indicators />
        </ServicesChartsDataProvider>
    );
};

export default IndicatorsWrapper;
